<template>
  <div id="contents">
    <div id="creator_bank_contact" class="page_contents">
      <div id="creator_bank_contact_area" v-if="confirm_flg == false && after_sending_flg == false">
        <section class="under_head creator_head">
          <h2>
            テレビ朝日映像<br class="pc_none">「クリエイターズバンク」
            <span>CREATORS BANK</span>
          </h2>
          <h2 class="margin_top_60">登録募集</h2>
        </section>

        <section class="under_top_text creator_text">
          <h4>動画制作サービス等に一緒に取り組んでくださる<br>動画編集・映像制作フリークリエイターを募集しております。<br></h4>
        </section>

        <section id="apology_text_link" class="apology_box">
          <p>【お詫び】弊社HP「クリエイターズバンク」登録募集における不具合のお詫びについて<br /><br />日頃より、弊社ホームページをご利用いただきまして誠にありがとうございます。<br /><br />2021年1月20日より、弊社のサーバシステムに障害が発生し、「クリエイターズバンク」ページより応募フォームを使用して「動画編集・映像制作クリエイター」にご応募いただいた情報のほとんどが、弊社に届いていなかったことが判明しました。<br />2月20日19時ごろ復旧し、現在は通常通りご応募いただけます。<br />応募いただいたクリエイターのみなさまには、ご応募いただいたにもかかわらず、弊社から何の連絡も無いことを不審に思った方もいらっしゃることと思います。ご心配、ご迷惑をお掛けしましたことを心より深くお詫び申し上げます。<br /><br />なお、この期間中に「動画編集・映像制作クリエイター」としてご応募いただいたみなさまのうち、弊社から応募完了の連絡が届かなかった方は、お手数をお掛けして大変恐縮ですが、再度「応募フォーム」よりご登録いただければ幸いです。<br /><br />引き続き、テレビ朝日映像株式会社ならびにクリエイターズバンクをよろしくお願いいたします。</p>
        </section>

        <section>
          <h3 class="section_title margin_base">会社の特徴</h3>
          <div class="flex_area service_box margin_top_0">
            <p>テレビ朝日映像は、企画提案・動画制作・動画広告運用・パッケージ撮影といった動画制作サービスを提供しています。<br>1958年の創業当初から、テレビ番組、映画、CM、ブランドムービー、動画広告などを多数生み出してまいりました。受賞歴も豊富にあり、数々の作品が評価されています。<br>官公庁をはじめ地方自治体、教育機関、民間企業の動画コンテンツも多く制作し、マスメディアではドキュメンタリーからバラエティーまで幅広い人気コンテンツを輩出しております。</p>
            <img src="../../static/creator_bank/img/company_photo.jpg">
          </div>
        </section>

        <section>
          <h3 class="section_title margin_base">仕事の特徴</h3>
          <div class="flex_area service_box service_box_reverse margin_top_0">
            <img src="../../static/creator_bank/img/creator_photo.jpg">
            <p>クライアントのご要望にお応えするハイクオリティな動画を制作し、その魅力を最大限に伝えていただきます。<br>案件によってはロケ・ドローン撮影などを行う仕事もあります。<br>企画や演出から考えるため、総合制作プロダクションならではのクリエイティブにチャレンジできます。<br>クライアントは大手企業や自治体まで幅広く、さまざまな案件を取り扱っているので、スキルアップにつながります。</p>
          </div>
        </section>
        <!--動画ジャンル-->
        <section id="genre">
          <h3 class="section_title margin_base">動画ジャンル</h3>
          <div class="flex_area box_area">
            <div>
              <h6>PR動画</h6>
            </div>
            <div>
              <h6>商品紹介</h6>
            </div>
            <div>
              <h6>広告・CM</h6>
            </div>
            <div>
              <h6>サービス紹介</h6>
            </div>
            <div>
              <h6>アプリ紹介</h6>
            </div>
            <div>
              <h6>会社紹介</h6>
            </div>
            <div>
              <h6>人材採用</h6>
            </div>
            <div>
              <h6>教育研修</h6>
            </div>
            <div>
              <h6>社員総会</h6>
            </div>
            <div>
              <h6>セミナー・説明会</h6>
            </div>
            <div>
              <h6>営業ツール</h6>
            </div>
            <div>
              <h6>展示会動画</h6>
            </div>
            <div>
              <h6>ドローン撮影</h6>
            </div>
            <div>
              <h6>長尺動画</h6>
            </div>
            <div>
              <h6>ミュージック<br>ビデオ（MV）</h6>
            </div>
            <div>
              <h6>ゲーム<br>プロモーション</h6>
            </div>
            <div>
              <h6>アニメーション</h6>
            </div>
            <div>
              <h6>導入事例</h6>
            </div>
            <div>
              <h6>施設・学校紹介</h6>
            </div>
            <div>
              <h6>広報・IR</h6>
            </div>
            <div>
              <h6>ブランディング</h6>
            </div>
            <div>
              <h6>デジタルサイネージ</h6>
            </div>
            <div>
              <h6>マニュアル</h6>
            </div>
            <div>
              <h6>テレビ番組</h6>
            </div>
          </div>
        </section>

        <section>
          <h3 class="section_title margin_base">応募条件</h3>

          <div class="creator_conditions margin_top_0">
            <h5>必須スキル</h5>
            <div>
              <p>スキルの判断材料として 過去作品（ポートフォリオ）の提出</p>
              <p>下記いずれかのツールでの動画編集実務経験1年以上</p>
              <ul>
                <li>Adobe Premiere</li>
                <li>Adobe After Effects</li>
                <li>Avid Media Composer</li>
                <li>Final Cut Pro</li>
              </ul>
            </div>
          </div>

          <div class="creator_conditions">
            <h5>歓迎条件</h5>
            <div>
              <ul>
                <li>ネット動画制作会社での業務経験</li>
                <li>テレビ制作業界での業務経験</li>
                <li>音楽PVやCMなど映像業界での業務経験</li>
              </ul>
            </div>
          </div>

          <div class="creator_conditions">
            <h5>求める人物像</h5>
            <div>
              <ul>
                <li>映像制作のプロとして仕事をしていらっしゃる方</li>
                <li>テレビ朝日映像の動画制作事業に関心のある方</li>
                <li>コミュニケーション能力が高く、チームで成果を出せる方</li>
              </ul>
            </div>
          </div>

        </section>

        <!--制作の流れ-->
        <section id="flow">
          <h3 class="section_title margin_base">登録の流れ</h3>
          <!--<div class="flex_area box_area">-->
          <img src="../../static/creator_bank/img/creator_flow.png" class="">
          <!--</div>-->

          <ol class="flow_list">
            <li>オンライン面談の可能性もございます。</li>
            <li>報酬その他の条件は、面談の際にご相談します。</li>
            <li>本登録は依頼を確約するものではありません。<br>ご経歴・スキルに合った案件に応じてご相談します。</li>
          </ol>
        </section>

        <section id="form" class="creator_form">
          <div class="box_shadow">
            <h3 class="section_title creator_form_title">応募フォーム</h3>
            <form id="app" action="" method="post">
              <ul>
                <li>
                  <label for="Name">
                    <h6>氏名<span>必須</span></h6>
                  </label><span class="check_erroer_text" v-for="(error, index) in NameError" :key="index">{{ error }}</span>
                  <input type="text" name="name" id="name" v-model="Name" v-bind:class="{'check_erroer_box': !NameErrorColor} ">
                </li>
                <li>
                  <h6>電話番号<span>必須</span></h6>
                  <span class="check_erroer_text" v-for="(error2, index) in TelError" :key="index">{{ error2 }}<br></span>
                  <input type="number" name="tel" id="tel" v-model="Tel" v-bind:class="{'check_erroer_box': !TelErrorColor} ">
                  <span class="check_erroer_text"><br>※ハイフンはなしでご入力ください</span>
                </li>
                <li>
                  <label for="Email">
                    <h6>メールアドレス<span>必須</span></h6>
                  </label>
                  <span class="check_erroer_text" v-for="(error3, index) in EmailError" :key="index">{{ error3 }}</span>
                  <input type="email" name="email" id="email" v-model="Email" v-bind:class="{'check_erroer_box': !EmailErrorColor} ">
                </li>
                <li>
                  <label for="Year">
                    <h6>生年月日<span>必須</span></h6>
                  </label>
                  <span class="check_erroer_text" v-for="(error4, index) in YearError" :key="index">{{ error4 }}<br></span>
                  <select ID="year" name="year" v-model="Year" v-bind:class="{'check_erroer_box': !YearErrorColor} ">
                    <option value="">-</option>
                    <option value="1900">1900</option>
                    <option value="1901">1901</option>
                    <option value="1902">1902</option>
                    <option value="1903">1903</option>
                    <option value="1904">1904</option>
                    <option value="1905">1905</option>
                    <option value="1906">1906</option>
                    <option value="1907">1907</option>
                    <option value="1908">1908</option>
                    <option value="1909">1909</option>
                    <option value="1910">1910</option>
                    <option value="1911">1911</option>
                    <option value="1912">1912</option>
                    <option value="1913">1913</option>
                    <option value="1914">1914</option>
                    <option value="1915">1915</option>
                    <option value="1916">1916</option>
                    <option value="1917">1917</option>
                    <option value="1918">1918</option>
                    <option value="1919">1919</option>
                    <option value="1920">1920</option>
                    <option value="1921">1921</option>
                    <option value="1922">1922</option>
                    <option value="1923">1923</option>
                    <option value="1924">1924</option>
                    <option value="1925">1925</option>
                    <option value="1926">1926</option>
                    <option value="1927">1927</option>
                    <option value="1928">1928</option>
                    <option value="1929">1929</option>
                    <option value="1930">1930</option>
                    <option value="1931">1931</option>
                    <option value="1932">1932</option>
                    <option value="1933">1933</option>
                    <option value="1934">1934</option>
                    <option value="1935">1935</option>
                    <option value="1936">1936</option>
                    <option value="1937">1937</option>
                    <option value="1938">1938</option>
                    <option value="1939">1939</option>
                    <option value="1940">1940</option>
                    <option value="1941">1941</option>
                    <option value="1942">1942</option>
                    <option value="1943">1943</option>
                    <option value="1944">1944</option>
                    <option value="1945">1945</option>
                    <option value="1946">1946</option>
                    <option value="1947">1947</option>
                    <option value="1948">1948</option>
                    <option value="1949">1949</option>
                    <option value="1950">1950</option>
                    <option value="1951">1951</option>
                    <option value="1952">1952</option>
                    <option value="1953">1953</option>
                    <option value="1954">1954</option>
                    <option value="1955">1955</option>
                    <option value="1956">1956</option>
                    <option value="1957">1957</option>
                    <option value="1958">1958</option>
                    <option value="1959">1959</option>
                    <option value="1960">1960</option>
                    <option value="1961">1961</option>
                    <option value="1962">1962</option>
                    <option value="1963">1963</option>
                    <option value="1964">1964</option>
                    <option value="1965">1965</option>
                    <option value="1966">1966</option>
                    <option value="1967">1967</option>
                    <option value="1968">1968</option>
                    <option value="1969">1969</option>
                    <option value="1970">1970</option>
                    <option value="1971">1971</option>
                    <option value="1972">1972</option>
                    <option value="1973">1973</option>
                    <option value="1974">1974</option>
                    <option value="1975">1975</option>
                    <option value="1976">1976</option>
                    <option value="1977">1977</option>
                    <option value="1978">1978</option>
                    <option value="1979">1979</option>
                    <option value="1980">1980</option>
                    <option value="1981">1981</option>
                    <option value="1982">1982</option>
                    <option value="1983">1983</option>
                    <option value="1984">1984</option>
                    <option value="1985">1985</option>
                    <option value="1986">1986</option>
                    <option value="1987">1987</option>
                    <option value="1988">1988</option>
                    <option value="1989">1989</option>
                    <option value="1990">1990</option>
                    <option value="1991">1991</option>
                    <option value="1992">1992</option>
                    <option value="1993">1993</option>
                    <option value="1994">1994</option>
                    <option value="1995">1995</option>
                    <option value="1996">1996</option>
                    <option value="1997">1997</option>
                    <option value="1998">1998</option>
                    <option value="1999">1999</option>
                    <option value="2000">2000</option>
                    <option value="2001">2001</option>
                    <option value="2002">2002</option>
                    <option value="2003">2003</option>
                    <option value="2004">2004</option>
                    <option value="2005">2005</option>
                    <option value="2006">2006</option>
                    <option value="2007">2007</option>
                    <option value="2008">2008</option>
                    <option value="2009">2009</option>
                    <option value="2010">2010</option>
                    <option value="2011">2011</option>
                    <option value="2012">2012</option>
                    <option value="2013">2013</option>
                    <option value="2014">2014</option>
                    <option value="2015">2015</option>
                    <option value="2016">2016</option>
                    <option value="2017">2017</option>
                    <option value="2018">2018</option>
                    <option value="2019">2019</option>
                    <option value="2020">2020</option>
                  </select> 年
                  <select name="Month" v-model="Month" v-bind:class="{'check_erroer_box': !MonthErrorColor} ">
                    <option value="">-</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                  </select> 月
                  <select name="day" v-model="Day" v-bind:class="{'check_erroer_box': !DayErrorColor} ">
                    <option value="">-</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                    <option value="24">24</option>
                    <option value="25">25</option>
                    <option value="26">26</option>
                    <option value="27">27</option>
                    <option value="28">28</option>
                    <option value="29">29</option>
                    <option value="30">30</option>
                    <option value="31">31</option>
                  </select> 日
                </li>
                <li>
                  <div>
                    <label for="Portfolio">
                      <h6>ポートフォリオ<span>必須</span></h6>
                    </label>
                    <span class="check_erroer_text" v-for="(error5, index) in PortfolioError" :key="index">{{ error5 }}</span>
                  </div>
                  <div>
                    <h6>URL or</h6>
                    <input type="text" name="portfolio" id="portfolio" v-model="PortfolioURL" v-bind:class="{'check_erroer_box': !PortfolioErrorColor} ">
                  </div>
                  <div>
                    <h6>PDF</h6>
                    <input type="file" name="file" @change="validate_uploads">
                  </div>
                </li>
                <li>
                  <label for="inquiry">
                  <h6>お問い合わせ</h6>
                  </label>
                  <textarea rows="12" name="inquiry" id="inquiry" v-model="Textarea"> </textarea>
                </li>
              </ul>
              <div class="check_area">
                <input type="checkbox" id="check" class="checkbox_size" v-model="Privacypolicy" />
                <label for="check"></label>
                <router-link v-bind:to="{name: 'privacypolicy'}" class="under_link" target="_blank">個人情報の取り扱いについて</router-link>に同意します
              </div>
              <p id="submit" class="base_button top_red_button top_request_button_width" v-on:click="checkForm">応募する</p>
              <!-- <input id="submit" class="base_button top_red_button top_request_button_width" type="submit" name="btn_Enter" value="登録する"> -->
            </form>
          </div>
        </section>
      </div>
      <div id="creator_bank_confirm_area" v-if="confirm_flg && after_sending_flg == false">
        <section class="under_head creator_head">
          <h5>下記内容にて、送信いたします。問題がなければ「送信」をクリックしてください。</h5>
        </section>

        <section class="under_top_text creator_text">

        </section>

        <section id="confirm" class="creator_text">
          <form action="" method="post">
            <div class="contact_box">
              <h6>氏名<span>必須</span></h6>
              <div class="contact_box_inner">
                <!--名前を読み込む-->
                {{ this.Name }}
              </div>
            </div>
            <div class="contact_box">
              <h6>電話番号<span>必須</span></h6>
              <div class="contact_box_inner">
                <!--電話番号を読み込む-->
                {{ this.Tel }}
              </div>
            </div>
            <div class="contact_box">
              <h6>メールアドレス<span>必須</span></h6>
              <div class="contact_box_inner">
                <!--メールアドレスを読み込む-->
                {{ this.Email }}
              </div>
            </div>
            <div class="contact_box">
              <h6>生年月日<span>必須</span></h6>
              <div class="contact_box_inner">
                <!--生年月日を読み込む-->
                {{ this.Year }}年{{ this.Month }}月{{ this.Day }}日
              </div>
            </div>
            <div class="contact_box" v-if="this.PortfolioURL">
              <h6>ポートフォリオ（URL）<span>必須</span></h6>
              <div class="contact_box_inner">
                <!--ポートフォリオ（PDF）を読み込む-->
                {{ this.PortfolioURL }}
              </div>
            </div>
            <div class="contact_box" v-if="this.PortfolioPDF">
              <h6>ポートフォリオ（PDF）<span>必須</span></h6>
              <div class="contact_box_inner">
                <!--ポートフォリオ（PDF）を読み込む-->
                {{ this.PortfolioPDF.name }}
              </div>
            </div>
            <div class="contact_box">
              <h6>お問い合わせ</h6>
              <div class="contact_box_inner">
                <!--お問い合わせ内容を読み込む-->
                {{ this.Textarea }}
              </div>
            </div>
            <div class="contact_button">
              <input class="base_button top_red_button top_request_button_width" type="button" v-on:click="mail_send" name="btn_Enter" value="送信する">
              <input class="base_button top_request_button_width" type="button" v-on:click="return_form" value="入力フォームに戻る">
            </div>
          </form>
        </section>
      </div>
      <div id="creator_bank_after_sending_area" v-if="confirm_flg && after_sending_flg">
         <section class="under_head creator_head">
          <h5>ご応募ありがとうございました。</h5>
        </section>
      </div>
    </div><!-- #creator_bank_contact -->
  </div><!-- #contents -->
</template>

<script>
import jQuery from '../../static/creator_bank/js/jquery-3.3.1.min.js'
global.jquery = jQuery
global.$ = jQuery
export default {
  name: 'creator_bank_contact',
  data() {
    return {
      api_url: this.$parent.api_base_url+'/api/creator_bank/send_mail.php',
      ErrorText: "※必須項目です",
      NameError: [],
      Name: null,
      NameErrorColor: true,
      TelError: [],
      Tel: null,
      TelErrorColor: true,
      EmailError: [],
      Email: null,
      EmailErrorColor: true,
      YearError: [],
      Year: 1990,
      YearErrorColor: true,
      Month: null,
      MonthErrorColor: true,
      Day: null,
      DayErrorColor: true,
      PortfolioError: [],
      PortfolioURL: null,
      PortfolioPDF: null,
      PortfolioErrorColor: true,
      Textarea: null,
      Privacypolicy: null,
      confirm_flg: false,
      after_sending_flg: false,
      headers: {
        'content-type': 'multipart/form-data'
      },
      hash: this.$route.hash,
    }
  },
  mounted () {
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
    $('.js-click_box').click(function(){
      var link = $(this).find('a').attr('href');
      console.log(link);
      window.open(link);
      return false;
    });
    $('#submit').addClass('disabled');
    $('#check').click(function() {
      if ($(this).prop('checked') == false) {
        $('#submit').addClass('disabled');
      } else {
        $('#submit').removeClass('disabled');
      }
    });
    //fromのスクロール位置の調整
    // $(function ($) {
    //   var form = document.getElementById("form");
    //   document.getElementById("re").onclick = function() {
    //     var invalids = form.querySelectorAll(':invalid');
    //     if (invalids.length > 0) {
    //       var rect = invalids[0].getBoundingClientRect();
    //       var y = rect.top + window.pageYOffset - window.innerHeight / 10;
    //       setTimeout(function() {
    //         scrollTo(0, y);
    //       }, 0);
    //     }
    //   };
    // })
    //クリエイター募集　チェック項目の判定
    $(function() {
      $('#submit').addClass('disabled');
      $('#check').click(function() {
        if ($(this).prop('checked') == false) {
          $('#submit').addClass('disabled');
        } else {
          $('#submit').removeClass('disabled');
        }
      });
    });
    //クリエイター募集 formスクロール
    $(function ($) {
      var form = document.getElementById("app");
      document.getElementById("submit").onclick = function() {
        var invalids = form.querySelectorAll('.check_erroer_text');
        if (invalids.length > 0) {
          var rect = invalids[0].getBoundingClientRect();
          var y = rect.top + window.pageYOffset - window.innerHeight / 2;
          setTimeout(function() {
            scrollTo(0, y);
          }, 0);
        }
      };
    });
    this.$nextTick(function () {
      if (this.hash) {
        const refName = this.hash.replace('#', '')
        this.smooth_scroll(refName)
      }
    })
  },
  methods: {
  mail_send: function(){
    console.log('sebd')
    console.log(this.PortfolioPDF)
    let formData = new FormData()
    formData.append('name',this.Name)
    let config = {
                  headers: {
                      'content-type': 'multipart/form-data',
                  }
              };
    formData.append('tel',this.Tel)
    formData.append('email',this.Email)
    formData.append('year',this.Year)
    formData.append('month',this.Month)
    formData.append('day',this.Day)
    formData.append('portfolio_url',this.PortfolioURL)
    formData.append('portfolio_pdf',this.PortfolioPDF)
    if(this.PortfolioPDF){
      formData.append('portfolio_pdf_name',this.PortfolioPDF.name)
    }
    formData.append('textarea',this.Textarea)
    console.log(formData)
    this.$axios
      .post(this.api_url,formData,config)
      .then(response => {
        console.log(response.data)
        if(response.data.response.header.status == 'success'){
          this.after_sending_flg = true
          scrollTo(0, 0)
        }else{
          alert('送信に失敗しました')
          this.after_sending_flg = false
        }
      })
      .catch(error => {
        console.log(error)
        this.error = true
      })
    return false
  },
    validate_uploads: function (event) {
      event.preventDefault();
      let file = event.target.files[0],
          name = file.name,
          size = file.size,
          type = file.type,
          errors = ''
      //拡張子は .pdf のみ許可
      if (type != 'application/pdf') {
        errors += '.pdfファイルのみ許可されています\n'
      }
      if (errors) {
        //errorsが存在する場合は内容をalert
        alert(errors)
        //valueを空にしてリセットする
        event.currentTarget.value = ''
      } else {
        this.PortfolioPDF = file
      }
    },
    checkForm: function (e) {
      //名前確認
      this.NameError = [];
      if (!this.Name) this.NameError.push(this.ErrorText);
      this.NameErrorColor = [];
      if (!this.Name)
        this.NameErrorColor = !this.NameErrorColor;

      //電話番号確認
      this.TelError = [];
      if (!this.Tel) this.TelError.push(this.ErrorText);
      this.TelErrorColor = [];
      if (!this.Tel)
        this.TelErrorColor = !this.TelErrorColor;

      //メール確認
      if (!this.Email) {
        this.EmailError = [];
        this.EmailError.push(this.ErrorText);
      } else if (!this.InvalidEmail(this.Email)) {
        this.EmailError = [];
        this.EmailError.push("メールアドレスの形式が異なります");
      }
      this.EmailErrorColor = [];
      if (!this.Email)
        this.EmailErrorColor = !this.EmailErrorColor;

      //生年月日確認
      this.YearError = [];
      if (!this.Year) {
        this.YearError.push(this.ErrorText);
      } else if (!this.Month) {
        this.YearError.push(this.ErrorText);
      } else if (!this.Day) {
        this.YearError.push(this.ErrorText);
      };
      this.YearErrorColor = [];
      if (!this.Year)
        this.YearErrorColor = !this.YearErrorColor;
      this.MonthErrorColor = [];
      if (!this.Month)
        this.MonthErrorColor = !this.MonthErrorColor;
      this.DayErrorColor = [];
      if (!this.Day)
        this.DayErrorColor = !this.DayErrorColor;

      //ポートフォリオ確認
      this.PortfolioError = [];
      if (!this.PortfolioURL && !this.PortfolioPDF) this.PortfolioError.push(this.ErrorText);
      this.PortfolioErrorColor = [];
      if (!this.PortfolioURL && !this.PortfolioPDF)
        this.PortfolioErrorColor = !this.PortfolioErrorColor;

      //入力確認
      if (
        !this.NameError.length &&
        !this.TelError.length &&
        !this.EmailError.length &&
        !this.YearError.length &&
        !this.PortfolioError.length) {
          this.confirm_flg = true
          return false;
        }
      e.preventDefault();
    },
    //メール@.com確認
    InvalidEmail: function (Email) {
      this.EmailError = [];
      var me = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return me.test(Email);
    },
    return_form: function(e){
      this.confirm_flg = false
      return false
    },
    smooth_scroll(refName) {
      const el = this.$refs[refName]
      var speed = 500;
      var href= '#' + refName;
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top;
      setTimeout(function () {
        $("html, body").animate({scrollTop:position}, speed, "swing");
      }, 1000);
      window.history.replaceState(null, '', location.pathname + '#' + this.$route.path );
      return false;
    },
  },
}
</script>

<style scoped>
</style>

<style scoped lang="sass">
  @import "../../static/creator_bank/css/creator_bank_style.sass"
</style>



// WEBPACK FOOTER //
// src/components/creator_bank_contact.vue